import { IDivider } from './types'
import css from './index.module.scss'


/** Компонент Divider */
export const Divider = ({
    id, className, variant = 'dark', type, size, margin, prefix, suffix, gap = '2px'
}: IDivider) => {
    const getType = () => {
        const marginHorizontalStyle: React.CSSProperties = {
            gap: gap,
            paddingLeft: margin || '0px',
            paddingRight: margin || '0px'
        }
        const marginVerticalStyle: React.CSSProperties = {
            gap: 0,
            paddingTop: margin || '0px',
            paddingBottom: margin || '0px'
        }

        const sizeHorizontalStyle: React.CSSProperties = {
            width: size || '100%',
            WebkitBoxShadow: `0px 0px 1px .2px ${variant === 'dark' ? '#000' : '#fff'}`,
            MozBoxShadow: `0px 0px 1px .2px ${variant === 'dark' ? '#000' : '#fff'}`,
            boxShadow: `0px 0px 1px .2px ${variant === 'dark' ? '#000' : '#fff'}`
        }
        const sizeVerticalStyle: React.CSSProperties = {
            height: size || '100%', width: '0px',

            WebkitBoxShadow: `0px 0px 1px .2px ${variant === 'dark' ? '#000' : '#fff'}`,
            MozBoxShadow: `0px 0px 1px .2px ${variant === 'dark' ? '#000' : '#fff'}`,
            boxShadow: `0px 0px 1px .2px ${variant === 'dark' ? '#000' : '#fff'}`
        }
    
        switch (type) {
            case 'horizontal': return { size: sizeHorizontalStyle, margin: marginHorizontalStyle }
            case 'vertical': return { size: sizeVerticalStyle, margin: marginVerticalStyle }
            default: return { size: sizeHorizontalStyle, margin: marginHorizontalStyle }
        }
    }



    return <div id={id} className={`${css.divider_container}`} style={getType().margin}>
        <div style={{ marginLeft: `${prefix && '4px'}`, textWrap: 'nowrap'}}>{prefix}</div>
        <span className={`${className}`} style={getType().size}></span>
        <div style={{ textWrap: 'nowrap'}}>{suffix}</div>
    </div>
}